import { render, staticRenderFns } from "./EditAreaStations.vue?vue&type=template&id=47c36ff2"
import script from "./EditAreaStations.vue?vue&type=script&lang=js"
export * from "./EditAreaStations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports